import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { PermissionKey } from 'auth/types';
import { TLocalesKeys } from 'localization';
import { UPDATE_COMPANY_PERMISSIONS } from 'schemas';

import {
  IUpdateCompanyPermissions,
  IUpdateCompanyPermissionsRequest,
  IUpdateCompanyPermissionsResponse,
} from './interfaces';

export const useUpdateCompanyPermissions = (): IUpdateCompanyPermissions => {
  const [updateCompanyPermissions, { loading }] = useMutation<
    IUpdateCompanyPermissionsResponse,
    IUpdateCompanyPermissionsRequest
  >(UPDATE_COMPANY_PERMISSIONS);

  return {
    updateCompanyPermissions,
    loading,
  };
};

export const getHint = (
  alias: PermissionKey,
  t: TTranslator<TLocalesKeys>
): string | null => {
  switch (alias) {
    case 'good_manage_add':
    case 'good_manage_dispose':
    case 'shop_manage':
    case 'booking_manage':
    case 'work_shift_open':
    case 'worker_task_manage':
    case 'worker_task_complete':
    case 'worker_manage':
    case 'client_manage':
    case 'loyalty_program_manage':
    case 'game_account_manage':
    case 'game_account_password_view':
    case 'shortcut_manage':
    case 'shortcut_browse':
    case 'host_command_manage':
    case 'host_manage':
    case 'comment_create':
    case 'comment_delete':
      return t(`permission.hint.${alias}`);
    default:
      return null;
  }
};

export const getBrowsePermission = (
  alias: PermissionKey
): PermissionKey | null => {
  switch (alias) {
    case 'good_manage_add':
    case 'good_manage_dispose':
    case 'shop_manage':
      return 'shop_browse';
    case 'host_command_manage':
    case 'host_manage':
    case 'booking_manage':
      return 'host_browse';
    case 'worker_task_manage':
    case 'worker_task_complete':
      return 'worker_task_browse';
    case 'worker_manage':
    case 'client_manage':
      return 'client_info';
    case 'loyalty_program_manage':
      return 'loyalty_program_browse';
    case 'game_account_manage':
    case 'game_account_password_view':
    case 'shortcut_browse':
    case 'shortcut_manage':
      return 'game_account_browse';
    case 'comment_create':
    case 'comment_delete':
      return 'comment_read';
    default:
      return null;
  }
};
